<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			
			  
			<div class="content-body">
				<!-- insertar barra de busqueda -->
				<app-search-bar [config]="configLocal.barraBusqueda" [useAccordionMode]="false" [fechaInicio]="configLocal.barraBusqueda.fechaInicio" [fechaFin]="configLocal.barraBusqueda.fechaFin" [nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker" (busqueda)="searchElementsByFilter($event)" [filtroEmisor]="true" [filtroSucursal]="true" [emisorClearable]="false" [sucursalClearable]="true" [modoCompraConsolidado]="true"> </app-search-bar>
				<section class="row content-resumen">
					<div class="col-8 grafico">
						<div class="card card-custom">
							<div style="text-align: center" class="mr-5 ml-5 pr-2 pl-2">
								<apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions" [yaxis]="chartOptions.yaxis" [legend]="chartOptions.legend" [fill]="chartOptions.fill" [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip" [xaxis]="chartOptions.xaxis"></apx-chart>
							</div>
						</div>
					</div>
					<div class="col-4 card-resumen">
						<div class="card card-custom gutter-b card-stretch">
							<!--begin::Header-->
							<div class="card-header border-0 pt-1">
								<div class="card-title">
									<div class="card-label">
										<div class="font-weight-bolder">Resumen de datos</div>
										<div class="font-size-sm text-muted mt-2">Según tus filtros de búsqueda</div>
									</div>
								</div>
							</div>
							<!--end::Header-->
							<!--begin::Body-->
							<div class="card-body d-flex flex-column px-0">
								<!--begin::Items-->
								<div class="flex-grow-1 card-spacer-x">
									<!--begin::Item-->
									<div class="d-flex align-items-center justify-content-between mb-5">
										<div class="d-flex align-items-center mr-2">
											<div class="symbol symbol-40 symbol-light mr-3 flex-shrink-0 d-none d-xl-block">
												<div class="symbol-label">
													<img src="assets/media/svg/flaticon/calculator.svg" alt="" class="h-50" />
												</div>
											</div>
											<div>
												<a href="#" class="font-size-h6 text-dark-75 text-hover-primary font-weight-bolder">{{ filter.tipoConsolidado == 2 ? 'Total Recibidos' : 'Total Emitidos' }}</a>
												<div class="font-size-sm text-muted font-weight-bold mt-1">Suma de totales de todos los DTE.</div>
												<!--<div class="font-size-sm text-muted font-weight-bold mt-1">{{ filter.modoCompras ? 'Las ND se han restado.' : 'Las NC se han restado.' }}</div>-->
											</div>
										</div>
										<div class="label label-light label-inline font-weight-bold text-dark-50 py-4 px-3 font-size-base">{{ totalDTE | currency : "$ " : "symbol" : "1.0-0" : "es" }}</div>
									</div>
									<!--end::Item-->
									<!--begin::Item-->
									<div class="d-flex align-items-center justify-content-between mb-5">
										<div class="d-flex align-items-center mr-2">
											<div class="symbol symbol-40 symbol-light mr-3 flex-shrink-0 d-none d-xl-block">
												<div class="symbol-label">
													<img src="assets/media/svg/flaticon/abacus.svg" alt="" class="h-50" />
												</div>
											</div>
											<div>
												<a href="#" class="font-size-h6 text-dark-75 text-hover-primary font-weight-bolder">  {{ filter.tipoConsolidado == 2 ? 'Cantidad Recibidos' : 'Cantidad Emitidos' }}</a>
												<div *ngIf="maxPlan > 0" class="font-size-sm text-muted font-weight-bold mt-1">El máximo de tu plan es de {{ maxPlan }}</div>
												<div *ngIf="maxPlan < 0" class="font-size-sm text-muted font-weight-bold mt-1">Tu plan es ilimitado</div>
											</div>
										</div>
										<div class="label label-light label-inline font-weight-bold text-dark-50 py-4 px-3 font-size-base">{{ cantidadDTE }} DTEs</div>
									</div>
									<!--end::Item-->
								</div>
								<!--end::Items-->
							</div>
							<!--end::Body-->
						</div>
					</div>
				</section>
				<section class="row mt-4">
					<div class="col-12">
						<div class="card card-custom mb-4">
						<div class="card-header py-3" (click)="isTypeCardCollapsed = !isTypeCardCollapsed" style="cursor:pointer">
							<h4 class="card-title mb-0">
							Resumen por Tipo de Documento
							<i class="ml-2"
								[ngClass]="{
								'fa fa-chevron-down': !isTypeCardCollapsed,
								'fa fa-chevron-right': isTypeCardCollapsed
								}"></i>
							</h4>
						</div>

						<div [ngbCollapse]="isTypeCardCollapsed" class="card-body">
							<ngx-datatable
								#tableConsolidadoByType
								*ngIf="componentStarted"
								class="material"
								[rows]="rowsByType"
								[columnMode]="'flex'"
								[headerHeight]="50"
								[rowHeight]="70"
								[footerHeight]="70"
								[scrollbarV]="false"
								[scrollbarH]="false"
								(sort)="utilities.onSortTable(tableConsolidadoByType, page)"
								[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: '' | translate, selectedMessage: false }"
								[externalSorting]="false"
							>
							<!-- Tipo Documento -->
								<ngx-datatable-column name="Tipo Documento" [flexGrow]="1.6" [headerClass]="'text-table-alignment'" [cellClass]="'text-table-alignment'">
									<ng-template ngx-datatable-header-template>
										Tipo Documento
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<ng-container *ngIf="row.codigoSii && row.codigoSii > 0; else plain">
										<a class="link" (click)="toMantenedorFromTipo(row)">
											{{ row.tipoDteNombre }}
										</a>
										</ng-container>
										<ng-template #plain>
										{{ row.tipoDteNombre }}
										</ng-template>
									</ng-template>
								</ngx-datatable-column>


								<!-- Cantidad -->
								<ngx-datatable-column name="Cantidad" prop="cantidadDocumentos" [flexGrow]="1" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'">
								</ngx-datatable-column>

								<!-- Exento -->
								<ngx-datatable-column name="Exento" prop="exento" [flexGrow]="1" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'">
									<ng-template ngx-datatable-cell-template let-row="row">
									{{ row.exento | currency:'$ ':'symbol':'1.0-0':'es' }}
									</ng-template>
								</ngx-datatable-column>

								<!-- Neto -->
								<ngx-datatable-column name="Neto" prop="neto" [flexGrow]="1" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'">
									<ng-template ngx-datatable-cell-template let-row="row">
									{{ row.neto | currency:'$ ':'symbol':'1.0-0':'es' }}
									</ng-template>
								</ngx-datatable-column>

								<!-- IVA -->
								<ngx-datatable-column name="IVA" prop="iva" [flexGrow]="1" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'">
									<ng-template ngx-datatable-cell-template let-row="row">
									{{ row.iva | currency:'$ ':'symbol':'1.0-0':'es' }}
									</ng-template>
								</ngx-datatable-column>

								<!-- Imp. Esp. -->
								<ngx-datatable-column name="Imp. Esp." prop="impuestosEspecificos" [flexGrow]="1" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'">
									<ng-template ngx-datatable-cell-template let-row="row">
									{{ row.impuestosEspecificos | currency:'$ ':'symbol':'1.0-0':'es' }}
									</ng-template>
								</ngx-datatable-column>

								<!-- Total -->
								<ngx-datatable-column name="Total" prop="total" [flexGrow]="1" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'">
									<ng-template ngx-datatable-cell-template let-row="row">
									{{ row.total | currency:'$ ':'symbol':'1.0-0':'es' }}
									</ng-template>
								</ngx-datatable-column>
								<ngx-datatable-footer>
									<ng-template ngx-datatable-footer-template>
										<div class="d-flex w-100 align-items-center" style="height: 70px; padding: 0 15px;">
											
											<!-- Columna Tipo Documento -->
											<div class="text-left font-weight-bold" style="flex: 1.6; padding: 0 5px;">
												Total
											</div>
											
											<!-- Columna Cantidad -->
											<div class="text-right font-weight-bold" style="flex: 1; padding: 0 5px;">
												{{ totalsByType?.cantidadDocumentos || 0 }}
											</div>
											
											<!-- Columna Exento -->
											<div class="text-right font-weight-bold" style="flex: 1; padding: 0 5px;">
												{{ (totalsByType?.exento || 0) | currency:'$ ':'symbol':'1.0-0':'es' }}
											</div>
											
											<!-- Columna Neto -->
											<div class="text-right font-weight-bold" style="flex: 1; padding: 0 5px;">
												{{ (totalsByType?.neto || 0) | currency:'$ ':'symbol':'1.0-0':'es' }}
											</div>
											
											<!-- Columna IVA -->
											<div class="text-right font-weight-bold" style="flex: 1; padding: 0 5px;">
												{{ (totalsByType?.iva || 0) | currency:'$ ':'symbol':'1.0-0':'es' }}
											</div>
											
											<!-- Columna Imp. Esp. -->
											<div class="text-right font-weight-bold" style="flex: 1; padding: 0 5px;">
												{{ (totalsByType?.impuestosEspecificos || 0) | currency:'$ ':'symbol':'1.0-0':'es' }}
											</div>
											
											<!-- Columna Total -->
											<div class="text-right font-weight-bold" style="flex: 1; padding: 0 5px;">
												{{ (totalsByType?.total || 0) | currency:'$ ':'symbol':'1.0-0':'es' }}
											</div>
											
										</div>
									</ng-template>
								</ngx-datatable-footer>
							</ngx-datatable>
						</div>
					</div>
				</div>
				</section>
				<section class="row mt-4">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header" (click)="isDateCardCollapsed = !isDateCardCollapsed" style="cursor: pointer">
								<h4 class="card-title">
									{{ filter.tipoConsolidado != 1 
										? (configLocal.table.title + " recibidos") 
										: (configLocal.table.title + " emitidos") 
									}}{{
										filterDescription
											? " -
                                    " + filterDescription
											: ""
									}}
									<i class="ml-2"
										[ngClass]="{
										'fa fa-chevron-down': !isDateCardCollapsed,
										'fa fa-chevron-right': isDateCardCollapsed
										}">
									</i>
								</h4>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0 btn-export">
									<button class="btn btn-warning float-right mr-5 mt-5" (click)="exportToExcel()" ngbTooltip="Utilice el filtro de búsqueda para acotar el rango a exportar" *ngIf="permissions.getPermission('40-18-32-20').asignado">
										<i class="flaticon-download-1"></i>
										Exportar
									</button>
								</div>
							</div>
							<div class="card-content">
								<div class="card-body" [ngbCollapse]="isDateCardCollapsed">
									<!-- seccion tabla -->
									<ngx-datatable
										#tableConsolidado
										*ngIf="componentStarted"
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(tableConsolidado, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
									>
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!isRowExpanded(row)" [class.datatable-icon-down]="isRowExpanded(row)" title="Expand/Collapse Row" (click)="toggleExpandRow(row)"> </a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-row-detail [rowHeight]="rowHeightValue" #myDetailRow>
											<ng-template let-row="row" ngx-datatable-row-detail-template>
												<div class="table-container">
													<div class="row ml-4 pl-3">
														<div class="cell">Fecha</div>
														<div class="cell-largo">Tipo DTE</div>
														<div class="cell">Emitidos</div>
														<div class="cell">Anulados</div>
														<div class="cell">Total Neto</div>
														<div class="cell">Total Exento</div>
														<div class="cell">Total IVA</div>
														<div class="cell">Total</div>
														<!-- Otras celdas -->
													</div>
													<ng-container *ngFor="let group of row.detalle">
														<div class="row ml-4 pl-3">
															<div class="cell">{{ group.fecha | date : "dd/MM/yyyy" }}</div>
															<div class="cell-largo">{{ group.tipoDTE }}</div>
															<div class="cell">
																<a [ngClass]="{ link: group.cantidadEmitidos > 0 }" (click)="group.cantidadEmitidos > 0 ? toMantenedorFromDetail(group, false) : null">{{ group.cantidadEmitidos }}</a>
															</div>
															<div class="cell">
																<a [ngClass]="{ link: group.cantidadAnulados > 0 }" (click)="group.cantidadAnulados > 0 ? toMantenedorFromDetail(group, true) : null">{{ group.cantidadAnulados }}</a>
															</div>
															<div class="cell">{{ group.totalNeto | currency : "$ " : "symbol" : "1.0-0" : "es" }}</div>
															<div class="cell">{{ group.totalExento | currency : "$ " : "symbol" : "1.0-0" : "es" }}</div>
															<div class="cell">{{ group.totalIva | currency : "$ " : "symbol" : "1.0-0" : "es" }}</div>
															<div class="cell">{{ group.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</div>
															<!-- Otras celdas -->
														</div>
													</ng-container>
												</div>

												<!-- <div *ngFor="let detailRow of row.rows" class="text-wrap">Fecha: {{ detailRow.fecha }} Emitidos: {{ detailRow.cantidadEmitidos }}</div> -->
											</ng-template>
										</ngx-datatable-row-detail>

										<ngx-datatable-column name="fecha" [flexGrow]="1" [sortable]="true" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="date-table-alignment">Fecha</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="date-table-alignment">{{ row.fecha | date : "dd/MM/yyyy" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="tipoDTE" [flexGrow]="1.6" [sortable]="true" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Tipo DTE</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.tiposDTE }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="CantidadEmitidos" [flexGrow]="1" [sortable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">{{ filter.tipoConsolidado == 2 ? 'Recibidos' : 'Emitidos' }}</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment"
													><a [ngClass]="{ link: row.emitidos > 0 }" (click)="row.emitidos > 0 ? toMantenedorFromGeneral(row, false) : null">{{ row.emitidos }}</a>
												</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="CantidadAnulados" [flexGrow]="1" [sortable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Anulados</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment"
													><a [ngClass]="{ link: row.anulados > 0 }" (click)="row.anulados > 0 ? toMantenedorFromGeneral(row, false) : null">{{ row.anulados }}</a></span
												></ng-template
											>
										</ngx-datatable-column>

										<ngx-datatable-column name="neto" [flexGrow]="1" [sortable]="true" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Total Neto</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.totalNeto | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="exento" [flexGrow]="1" [sortable]="true" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Total Exento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.totalExento | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="iva" [flexGrow]="1" [sortable]="true" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Total IVA</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.totalIva | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="total" [flexGrow]="1" [sortable]="true" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Total</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible ;min-width: 45px;" appendTo="body">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableConsolidado.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!--section movil -->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
									>
										<ngx-datatable-column [width]="10" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!isRowExpanded(row)" [class.datatable-icon-down]="isRowExpanded(row)" title="Expand/Collapse Row" (click)="toggleExpandRowMobile(row)"> </a>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-row-detail [rowHeight]="rowHeightValue" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap" *ngFor="let group of row.detalle">
													Fecha: {{ row.fecha | date : "dd/MM/yyyy" }},&nbsp; TipoDte: {{ group.tipoDTE }},&nbsp; Emitidos: <a [ngClass]="{ link: group.cantidadEmitidos > 0 }" (click)="group.cantidadEmitidos > 0 ? toMantenedorFromDetail(group, false) : null">{{ group.cantidadEmitidos }}</a
													>,&nbsp; Anulados: <a [ngClass]="{ link: group.cantidadAnulados > 0 }" (click)="group.cantidadAnulados > 0 ? toMantenedorFromDetail(group, true) : null">{{ group.cantidadAnulados }}</a
													>, &nbsp; Total: {{ group.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}
												</div>
												<!-- <div *ngFor="let detailRow of row.rows" class="text-wrap">Fecha: {{ detailRow.fecha }} Emitidos: {{ detailRow.cantidadEmitidos }}</div> -->
											</ng-template>
										</ngx-datatable-row-detail>

										<ngx-datatable-column name="fecha" [flexGrow]="2.4" [sortable]="true" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'" [resizeable]="true">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="date-table-alignment text-wrap">Fecha</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="date-table-alignment text-wrap" style="font-size: 11px">{{ row.fecha | date : "dd/MM/yyyy" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="tipoDTE" [flexGrow]="1.2" [sortable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment text-wrap">Tipo DTE</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap" style="font-size: 12px">{{ row.tiposDTE }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="CantidadEmitidos" [flexGrow]="2.1" [sortable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment text-wrap">Emitidos</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment text-wrap" style="font-size: 12px"
													><a [ngClass]="{ link: row.emitidos > 0 }" (click)="row.emitidos > 0 ? toMantenedorFromGeneral(row, false) : null">{{ row.emitidos }}</a>
												</span></ng-template
											>
										</ngx-datatable-column>
										<!--<ngx-datatable-column name="CantidadAnulados" [flexGrow]="1" [sortable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'" [resizeable]="false">
										<ng-template let-column="column" ngx-datatable-header-template>
											<span class="text-table-alignment ml-3 text-wrap">Anulados</span>
										</ng-template>
										<ng-template ngx-datatable-cell-template let-row="row"
											><span class="number-table-alignment text-wrap" style="font-size: 12px;"
												><a [ngClass]="{ link: row.anulados > 0 }" (click)="row.anulados > 0 ? toMantenedorFromGeneral(row, false) : null">{{ row.anulados }}</a></span
											></ng-template
										>
									</ngx-datatable-column>-->
										<ngx-datatable-column name="total" [flexGrow]="1.7" [sortable]="true" [headerClass]="'number-table-alignment'" [cellClass]="'number-table-alignment'" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment text-wrap">Total</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment text-wrap" style="font-size: 12px; text-align: center">{{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>
														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>
